import React, { useState } from 'react';
import './CollapsibleSection.css';

interface CollapsibleSectionProps {
  title: string;
  icon?: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  className?: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  icon,
  children,
  defaultExpanded = false,
  className = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`collapsible-section ${className}`}>
      <div className="collapsible-header" onClick={toggleExpanded}>
        <h3>
          {icon && <span className="icon">{icon}</span>}
          {title}
        </h3>
        <button 
          className={`collapsible-toggle ${isExpanded ? 'expanded' : ''}`}
          aria-label={isExpanded ? 'Collapse section' : 'Expand section'}
        >
          ▼
        </button>
      </div>
      <div className={`collapsible-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
        {children}
      </div>
    </div>
  );
};

export default CollapsibleSection;








